export default {
    getPlaces(data) {

        const api = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'
        const token = 'pk.eyJ1IjoiZmxlZ2F0ZSIsImEiOiJja3ZtZG1jNTE1OG5mMnFva3Z5YWdlODNoIn0.QhMbHz4244aoeOsopbb5PQ'
        const endpoint = api + encodeURI(data) + '.json?country=FR&types=' + encodeURI('postcode,place,region,address') + '&access_token=' + token

        return new Promise((resolve, reject) => {

            let request = new XMLHttpRequest();

            request.open('GET', endpoint, true);

            request.onload = function() {
                if (this.status >= 200 && this.status < 400){

                    const results = JSON.parse(this.response)
                    resolve(results.features)

                } else reject(new Error('An error occured, data response has failed'))
            }

            request.onerror = function() {
                reject(new Error('An error occured, data response has failed'))
            }

            request.send();

        })

    }
}
